import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Image from '../../../components/AppImage';

const ProfileSection = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: "John",
    lastName: "Anderson",
    email: "john.anderson@cranedealer.com",
    company: "Anderson Heavy Equipment",
    phone: "+1 (555) 123-4567",
    jobTitle: "Equipment Manager",
    location: "Dallas, TX"
  });

  const [formData, setFormData] = useState(profileData);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors?.[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.firstName?.trim()) {
      newErrors.firstName = 'First name is required';
    }

    if (!formData?.lastName?.trim()) {
      newErrors.lastName = 'Last name is required';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/?.test(formData?.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData?.company?.trim()) {
      newErrors.company = 'Company name is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSave = () => {
    if (validateForm()) {
      setProfileData(formData);
      setIsEditing(false);
      // Here you would typically make an API call to save the data
      console.log('Profile updated:', formData);
    }
  };

  const handleCancel = () => {
    setFormData(profileData);
    setErrors({});
    setIsEditing(false);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <Icon name="User" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-text-primary">Profile Information</h3>
        </div>
        {!isEditing &&
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsEditing(true)}
          iconName="Edit"
          iconPosition="left">

            Edit Profile
          </Button>
        }
      </div>
      <div className="flex flex-col lg:flex-row lg:space-x-8">
        {/* Profile Picture */}
        <div className="flex flex-col items-center mb-6 lg:mb-0">
          <div className="relative">
            <div className="w-24 h-24 rounded-full overflow-hidden bg-muted border-4 border-border">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1ce6312b5-1762274557265.png"
                alt="Professional headshot of John Anderson, middle-aged man with brown hair in business attire"
                className="w-full h-full object-cover" />

            </div>
            {isEditing &&
            <Button
              variant="outline"
              size="icon"
              className="absolute -bottom-2 -right-2 w-8 h-8 rounded-full bg-surface border-2 border-border"
              iconName="Camera" />

            }
          </div>
          <p className="text-sm text-text-secondary mt-2 text-center">
            {isEditing ? 'Click to change photo' : 'Profile Photo'}
          </p>
        </div>

        {/* Profile Form */}
        <div className="flex-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="First Name"
              name="firstName"
              value={formData?.firstName}
              onChange={handleInputChange}
              disabled={!isEditing}
              error={errors?.firstName}
              required />

            
            <Input
              label="Last Name"
              name="lastName"
              value={formData?.lastName}
              onChange={handleInputChange}
              disabled={!isEditing}
              error={errors?.lastName}
              required />

            
            <Input
              label="Email Address"
              name="email"
              type="email"
              value={formData?.email}
              onChange={handleInputChange}
              disabled={!isEditing}
              error={errors?.email}
              required
              className="md:col-span-2" />

            
            <Input
              label="Company"
              name="company"
              value={formData?.company}
              onChange={handleInputChange}
              disabled={!isEditing}
              error={errors?.company}
              required />

            
            <Input
              label="Job Title"
              name="jobTitle"
              value={formData?.jobTitle}
              onChange={handleInputChange}
              disabled={!isEditing} />

            
            <Input
              label="Phone Number"
              name="phone"
              type="tel"
              value={formData?.phone}
              onChange={handleInputChange}
              disabled={!isEditing} />

            
            <Input
              label="Location"
              name="location"
              value={formData?.location}
              onChange={handleInputChange}
              disabled={!isEditing} />

          </div>

          {isEditing &&
          <div className="flex items-center space-x-3 mt-6">
              <Button
              variant="default"
              onClick={handleSave}
              iconName="Check"
              iconPosition="left">

                Save Changes
              </Button>
              <Button
              variant="outline"
              onClick={handleCancel}
              iconName="X"
              iconPosition="left">

                Cancel
              </Button>
            </div>
          }
        </div>
      </div>
    </div>);

};

export default ProfileSection;